import React, { useRef } from "react";
import Container from "../ui/Container";
import EyebrowTitle from "../ui/EyebrowTitle";
import EntryContent from "../ui/EntryContent";
import SiteLink from "../ui/SiteLink";
import { PortableText } from "@portabletext/react";
import { portableTextUtils } from "../sanity/portableTextUtils";
import Section from "../../components/ui/Section";
import { GatsbyImage } from "gatsby-plugin-image";
import Button from "../ui/Button";
import {
  motion,
  useScroll,
  useSpring,
  useTransform,
  MotionValue,
} from "framer-motion";

const Campaign = ({ data }) => {
  const {
    campaignBadge,
    campaignTitle,
    _rawCampaignbDescription,
    campaignCta,
    campaignImage,
  } = data;

  function useParallax(value: MotionValue<number>, distance: number) {
    return useTransform(value, [0, 1], [-distance, distance]);
  }

  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref });
  const scaleY = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });
  const y = useParallax(scaleY, 50);

  return (
    <Section className="overflow-hidden bg-secondary !py-12">
      <Container>
        <div className="mb-[2rem] flex flex-col gap-8 sm:mb-16 lg:gap-16 xl:flex-row">
          <div className="flex flex-col items-start xl:max-w-screen-sm">
            <EyebrowTitle
              label={campaignBadge}
              as="p"
              center={false}
              className="text-foreground before:bg-foreground"
            />
            <EntryContent className="text-foreground">
              <h2
                dangerouslySetInnerHTML={{
                  __html: campaignTitle,
                }}
                ref={ref}
              />
              <div className="text-h5 text-[#1C1B1F]/70">
                <PortableText
                  value={_rawCampaignbDescription}
                  components={portableTextUtils}
                />
              </div>
            </EntryContent>
            <Button
              asChild
              size={"lg"}
              variant={"default"}
              className="mt-2 w-auto self-center md:self-start"
            >
              <SiteLink
                to={campaignCta.link}
                external={campaignCta.isExternal}
                iconExternal={campaignCta.isExternal}
              >
                {campaignCta.label}
              </SiteLink>
            </Button>
          </div>

          <motion.div
            style={{ y }}
            className="flex flex-col justify-end pt-[4rem] xl:pt-0"
          >
            <GatsbyImage
              image={campaignImage.asset.gatsbyImageData}
              alt={campaignTitle}
              className="mx-auto -mb-[12rem] mt-[6rem]  xl:mt-0"
            />
          </motion.div>
        </div>
      </Container>
    </Section>
  );
};

export default Campaign;
